export const escapeHtml = (unsafe) => {
	let string = '';
	if (unsafe != null) {
		string = String(unsafe)
			.replaceAll('&', '&amp;')
			.replaceAll('<', '&lt;')
			.replaceAll('>', '&gt;')
			.replaceAll('"', '&quot;')
			.replaceAll('\'', '&#039;');
	}
	return string;
};
/**
 * @param {string[]} html_strings
 * @param {*[]} unsafe_values
 * @returns {string}
 */
export const escape_html_template = (html_strings, ...unsafe_values) => {
	let finalHtml = '';

	for (let i = 0; i < unsafe_values.length; i++) {
		finalHtml += html_strings[i] + escapeHtml(unsafe_values[i]);
	}

	// Add the last string literal
	finalHtml += html_strings[html_strings.length - 1];


	return finalHtml;
};


/**
 * @param {string[]} html_strings
 * @param {string[]} safe_html_strings
 * @returns {string}
 */
export const html_template = (html_strings, ...safe_html_strings) => {
	let finalHtml = '';

	for (let i = 0; i < safe_html_strings.length; i++) {
		finalHtml += html_strings[i] + safe_html_strings[i];
	}

	// Add the last string literal
	finalHtml += html_strings[html_strings.length - 1];


	return finalHtml;
};

